import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from "../../asstes/images/logo.png";
import mobileLogo from "../../asstes/images/mobileLogo.png";

const LoginNav = () => {
    const navigate = useNavigate()
    const Logiut = ()=>{
      navigate("/signup")
  
    }
  
  return (
    <div className=' shadow-lg bg-white lg:h-[100px] h-[66px] fixed w-[100%] z-20 lg:flex hidden items-center'>
    <div className="container">
       <div className='flex items-center justify-between'>
          <div className='logo -mt-2'>
              <Link className=" hidden lg:flex" to={"/"}><img src={logo}  alt=""/></Link>
              <Link className=" lg:hidden" to={"/"}><img src={mobileLogo}  alt=""/></Link>
          </div>

            <div className='flex items-center gap-2'>
                <p className='text-[24px] font-normal'>¿Ya eres parte de ciberconta?</p>
                <button onClick={Logiut} type='submit' className='py-4 px-5 bg-[#4285F4] text-white text-[14px] font-medium rounded-md md:text-[24px]'>Regístrate</button>
            </div>
      </div> 
    </div>
</div>
  )
}

export default LoginNav